import { useSponsorStudy } from "src/pages/study/use-sponsor-study"
import { useQuery } from "@tanstack/react-query"
import { useRouteParams } from "@myvp/shared/src/hooks/use-route-params"
import studyRouteNames from "src/pages/study/study-route-names"

export const useStudyHomeLoadTimestamp = () => {
  const { globalSponsorStudyId } = useRouteParams(studyRouteNames.reports)
  const { data: sponsorStudy } = useSponsorStudy()

  const query = useQuery({
    queryKey: ["studyHomeLoadTimestamp", globalSponsorStudyId],
    queryFn: () => {
      const storageKey = "initial-page-load-time" + globalSponsorStudyId
      let value = window.sessionStorage.getItem(storageKey)
      if (value) {
        return value as string
      } else {
        value =
          sponsorStudy?.mostRecentDate.toISOString() ?? new Date().toISOString()
        window.sessionStorage.setItem(storageKey, value)
        return value
      }
    },
    enabled: !!sponsorStudy,
    staleTime: Infinity,
  })

  return query.data
}
